<script setup lang="ts">
import { defineProps } from 'vue';
import { ProjectVisibility } from '@/dashboard/types/project_visibility';
import LinkIcon from '@/dashboard/vue/components/icons/LinkIcon.vue';
import LockIcon from '@/dashboard/vue/components/icons/LockIcon.vue';
import TeamIcon from '@/dashboard/vue/components/icons/TeamIcon.vue';

const props = defineProps<{
  type: ProjectVisibility;
}>();
</script>

<template>
  <span v-if="props.type === 'private'" class="flex items-center gap-xs">
    <LockIcon stroke-class="stroke-black dark:stroke-gray-500" fill-class="fill-black dark:fill-gray-500" />
    <span class="text-caption-s text-black dark:text-gray-500">Private</span>
  </span>

  <span v-if="props.type === 'link'" class="flex items-center gap-xs">
    <LinkIcon class="stroke-black dark:stroke-gray-500" />
    <span class="text-caption-s text-black dark:text-gray-500">Viewable via link</span>
  </span>

  <span v-if="props.type === 'team'" class="flex items-center gap-xs">
    <TeamIcon class="stroke-black dark:stroke-gray-500" />
    <span class="text-caption-s text-black dark:text-gray-500">Shared with the team</span>
  </span>
</template>
